export enum NumberOfLinesEnum {
  ALL = 'allLines',
  ONE = 'oneLine',
  TWO = 'twoLines',
}

export default NumberOfLinesEnum
